import { apiClient } from './client.tsx';
import type {
  CreateChainStoreContractRequest,
  UpdateChainStoreContractRequest,
  DownloadChainStoreContractAttachmentRequest,
  UploadChainStoreContractAttachmentRequest,
  DeleteChainStoreContractAttachmentRequest,
  UpdateChainStoreContractStoresRequest,
  PublishChainStoreContractRequest,
} from './requests/chain-store-contract-request.ts';

import type {
  CreateChainStoreContractResponse,
  DownloadUrlResponse,
} from './responses/chain-store-contract-response.ts';

import type { ChainStoreContract } from '../models/chain-store-contract.ts';

export const fetchChainStoreContract = (partnerId: string, id: string) =>
  apiClient
    .get<{
      data: ChainStoreContract;
    }>(`/v2/partners/${partnerId}/chain_store_contracts/${id}`)
    .then((res) => res.data);

export const createChainStoreContract = (
  request: CreateChainStoreContractRequest,
) =>
  apiClient
    .post<CreateChainStoreContractResponse>(
      `/v2/partners/${request.partnerId}/chain_store_contracts`,
      request,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data);

export const updateChainStoreContract = ({
  partnerId,
  id,
  ...restRequest
}: UpdateChainStoreContractRequest) =>
  apiClient
    .put<string>(
      `/v2/partners/${partnerId}/chain_store_contracts/${id}`,
      restRequest,
    )
    .then((res) => res.data);

export const downloadChainStoreContractAttachment = (
  request: DownloadChainStoreContractAttachmentRequest,
) =>
  apiClient
    .get<DownloadUrlResponse>(
      `/v2/partners/${request.partnerId}/chain_store_contracts/${request.contractId}/attachments/${request.attachmentId}/get_download_url`,
    )
    .then((res) => res.data);

export const uploadChainStoreAttachment = (
  request: UploadChainStoreContractAttachmentRequest,
) =>
  apiClient
    .post<string>(
      `/v2/partners/${request.partnerId}/chain_store_contracts/${request.contractId}/upload`,
      request,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data);

export const deleteChainStoreAttachment = (
  request: DeleteChainStoreContractAttachmentRequest,
) =>
  apiClient
    .delete<string>(
      `/v2/partners/${request.partnerId}/chain_store_contracts/${request.contractId}/attachments/${request.attachmentId}`,
    )
    .then((res) => res.data);

export const updateChainStoreContractStores = (
  request: UpdateChainStoreContractStoresRequest,
) =>
  apiClient
    .put<string>(
      `/v2/partners/${request.partnerId}/chain_store_contracts/${request.contractId}/update_chain_stores`,
      { chainStoreIds: request.chainStoreIds },
    )
    .then((res) => res.data);

export const publishChainStoreContract = (
  request: PublishChainStoreContractRequest,
) =>
  apiClient
    .post<string>(
      `/v2/partners/${request.partnerId}/chain_store_contracts/${request.id}/publish`,
    )
    .then((res) => res.data);
